module.exports = __webpack_public_path__ + "img/2.f3343b0d.png";